import { isString } from 'lodash';

export function trimValue<T>(value: T) {
  if (isString(value)) {
    return value.trim();
  }

  return value;
}

export const trimObject = (object: any) => {
  const newObject: Record<string, any> = {};

  Object.keys(object).forEach((key: string) => {
    newObject[key] = trimValue(object[key]);
  });

  return newObject;
};

export const compileFormData = (body: any) => {
  const formData = new FormData();

  Object.keys(trimObject(body)).forEach((key) => {
    if (Array.isArray(body[key])) {
      body[key].forEach((e: string) => {
        formData.append(`${key}[]`, e);
      });
    } else {
      formData.append(key, body[key]);
    }
  });

  return formData;
};
